import { Flex } from 'antd'
import useLang from '@/utils/hooks/use-lang'
import FullScreenBanner from '@/components/full-screen-banner'
import PageWrapper from '@/components/page-wrapper'
import Icon from '@/components/icon'
import { i18nAi, type AiProps } from '@/assets/content/ai'
import Styles from './style.module.scss'

export default function AI() {
  const [lang] = useLang()
  const { banner, subBanner, ContentBanner } = i18nAi[lang] as AiProps

  return (
    <PageWrapper soul>
      <FullScreenBanner vertical image={banner.image} className={Styles.mainBanner}>
        <h1>{banner.title}</h1>
        <div>{banner.description}</div>
      </FullScreenBanner>
      <FullScreenBanner vertical image={subBanner.image} className={Styles.subBanner}>
        <h3>{subBanner.title}</h3>
        <Flex vertical className={Styles.benefits}>
          <div className={Styles.title}>{subBanner.benefits.title}</div>
          <Flex className={Styles.list}>
            {subBanner.benefits.list.map(d => (
              <Flex key={d.label} vertical align='center' justify='center'>
                <Icon name={d.icon}></Icon>
                <div className={Styles.label}>{d.label}</div>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </FullScreenBanner>
      <FullScreenBanner vertical image={ContentBanner.image} className={Styles.contentBanner}>
        <h2>{ContentBanner.title}</h2>
        <Flex vertical className={Styles.offers}>
          <div className={Styles.title}>{ContentBanner.offers.title}</div>
          <Flex className={Styles.list}>
            {ContentBanner.offers.list.map((d, i) => (
              <Flex vertical align='center' justify='center' key={i}>
                <div className={Styles.title}>{d.title}</div>
                <div className={Styles.description}>{d.description}</div>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </FullScreenBanner>
    </PageWrapper>
  )
}
